<template>
  <div data-grm-comp="RoomCBT" class="bg-white flex">
    <template v-if="hasEmceeRole()">
      <div class="min-w-0 flex-1 flex justify-center">
        <RoomDocView roomGroupId="default" class="flex-1 h-full" />
        <RoomDocPaging class="absolute top-2" />
      </div>
      <div class="min-w-0 flex-1">
        <RoomCBTView />
      </div>
      <div>
        <RoomCBTViewInfo />
      </div>
    </template>
    <template v-else>
      <div class="flex-1 flex justify-center bg-gray-50">
        <RoomDocView roomGroupId="default" class="flex-1 h-full" />
        <RoomDocPaging class="absolute top-2" />
      </div>
      <div class="w-40 border-l p-2 overflow-y-auto relative">
        <RoomCBTTimer class="w-full" />
        <div class="mt-2">
          <div v-for="(roomCBTQuestion, i) in getUserQuestionList()"
               :key="roomCBTQuestion.questionId"
               class="flex items-center gap-1"
               :class="i !== 0 && (i+1) % roomCBTQuestion.answerList.length === 0 && (i+1) !== roomCBT.questionCnt ? 'border-b pb-3 mb-3' : ''"
          >
            <span class="w-8 text-sm inline-block">{{ number(i+1) }}.</span>
            <div class="flex items-center gap-0.5">
              <button v-for="(answer, j) in roomCBTQuestion.answerList"
                      :key="answer.answerOrder"
                      class="w-4 h-4 rounded-full text-xs flex justify-center items-center"
                      :class="answer.correct ? 'bg-black' : 'border'"
                      @click="onChangeAnswer(answer.correct, answer.answerId, answer.answerOrder, roomCBTQuestion)"
              >{{ j+1 }}</button>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <GrmBtn class="w-full" @click="onComplete">제출하기</GrmBtn>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

import RoomCBTViewInfo from "@/components/Room/CBT/RoomCBTViewInfo.vue";
import RoomDocPaging from "@/components/Room/Doc/Paging.vue";
import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import RoomCBTTimer from "@/components/Room/CBT/RoomCBTTimer.vue";
import RoomCBTView from "@/components/Room/CBT/RoomCBTView.vue";
import RoomDocView from "@/components/Room/Doc/View.vue";

export default {
  name: 'RoomCBT',
  components: {
    RoomDocView,
    RoomCBTView,
    RoomCBTTimer,
    GrmBtn,
    RoomDocPaging,
    RoomCBTViewInfo,
  },
  mounted() {
    (async () => {
      try {
        const roomCBTUserDoc = await this.getRoomCBTUserDoc({
          roomCbtId: this.roomCBT.roomCbtId,
          userId: this.me.userId
        })

        if (roomCBTUserDoc) {
          await this.changeRoomCBTUserDocPage({
            roomGroupId: roomCBTUserDoc.roomGroupId,
            docId: roomCBTUserDoc.docId,
            docPageId: roomCBTUserDoc.docPageId,
            roomCbtId: this.roomCBT.roomCbtId,
            userId: this.me.userId
          });
        }
      } catch (e) {
        console.error(e)
      }
    })()
  },
  computed: {
    ...mapGetters('user', [
      'me',
      'hasEmceeRole'
    ]),
    ...mapGetters('cbt', [
      'isCompleteCBT',
      'getUserQuestionList',
    ]),
    ...mapState('cbt', [
      'roomCBT',
      'roomCBTDoc'
    ]),

    number() {
      return (i) => {
        if (i < 10) return `00${i}`
        if (i < 100) return `0${i}`
        return i
      }
    },
  },
  methods: {
    ...mapActions('room', [
      'changeRoomMode'
    ]),
    ...mapActions('cbt', [
      'getRoomCBTUserDoc',
      'completeRoomCBTUser',
      'changeRoomCBTUserDocPage',
      'submitRoomCBTUserAnswerList'
    ]),

    onChangeAnswer(correct, answerId, answerOrder, question) {
      if (this.isCompleteCBT()) {
        this.$alert(this.$t('roomCbt.alert.alreadyAnswer'))
        return
      }

      let userAnswerList = question.answerList.filter(answer => answer.correct)

      if (correct) {
        const i = userAnswerList.findIndex(answer => answer.answerId === answerId)
        if (i > -1) {
          userAnswerList.splice(i, 1)
        }
      } else {
        if (question.correctAnswerCnt === userAnswerList.length) {
          userAnswerList = []
        }

        userAnswerList.push({
          answerId,
          answerOrder
        })
        userAnswerList.sort((a, b) => a.answerOrder - b.answerOrder)
      }

      const userQuestion = {
        questionOrder: question.questionOrder,
        questionId: question.questionId,
        userAnswerList: userAnswerList
      }

      this.submitRoomCBTUserAnswerList({
        userQuestion,
        roomCbtId: this.roomCBT.roomCbtId,
        userId: this.me.userId
      })
    },
    onComplete() {
      if (this.isCompleteCBT()) {
        this.$alert(this.$t('roomCbt.alert.alreadyAnswer'))
        return
      }

      this.$confirm({
        text: this.$t('roomCbt.alert.answerConfirm'),
        ok: async () => {
          try {
            await this.completeRoomCBTUser({
              roomCbtId: this.roomCBT.roomCbtId,
              userId: this.me.userId
            })

            this.$alert(this.$t('roomCbt.alert.completeAnswer'))
          } catch (e) {
            console.error(e)
            this.$alert(this.$t('roomCbt.alert.failedAnswer'))
          }
        }
      })
    }
  }
}
</script>